import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { OutcomeSheet } from "@/components/leads/OutcomeSheet";

/** Re-opens the mandatory outcome sheet if the agent left a call/WhatsApp/email without saving. */
export const PendingOutcomeGate = () => {
  const [lead, setLead] = useState(null);
  const check = useCallback(() => {
    if (window.__crmOutcomeOpen) return;
    api.get("/v2/leads", { params: { tab: "updates" } }).then((r) => {
      const p = (r.data || []).find((l) => l.mine?.pending_outcome);
      setLead((cur) => cur || p || null);
    }).catch(() => {});
  }, []);
  useEffect(() => {
    const t = setTimeout(check, 1500);
    const onVis = () => document.visibilityState === "visible" && setTimeout(check, 1500);
    document.addEventListener("visibilitychange", onVis);
    return () => { clearTimeout(t); document.removeEventListener("visibilitychange", onVis); };
  }, [check]);
  if (!lead) return null;
  return (
    <OutcomeSheet open lead={lead} channel={lead.mine.pending_outcome.channel}
      onDone={() => { setLead(null); window.dispatchEvent(new CustomEvent("crm:lead-saved")); }} />
  );
};
